import { FileImageOutlined, EditOutlined, ProductOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import LogoSettingListView from '../components/officer/LogoSettingListView';
import SignSettingListView from '../components/officer/SignSettingListView';
import DDSProductSettingListView from '../components/officer/DDSProductSettingListView';
import URLTabs from '../components/common/URLTabs';

export default function DDSSettingView() {
  const { t, i18n } = useTranslation();

  return (
    <div>
      <URLTabs
        destroyInactiveTabPane={true}
        defaultActiveKey='#logo'
        items={[
          {
            key: "#logo", 
            label: <span><FileImageOutlined /> {t("logo_setting")}</span>, 
            children: <LogoSettingListView/>,
          },
          {
            key: "#signed", 
            label: <span><EditOutlined /> {t("signed_setting")}</span>, 
            children: <SignSettingListView />,
          },
          {
            key: "#product", 
            label: <span><ProductOutlined /> {t("product_setting")}</span>, 
            children: <DDSProductSettingListView />,                                                                
          }
        ]} />
    </div>
  )
}